import { bus } from "@/main";
import { getMenuEntry } from "@/data/models/menu.model";
import router from "@/router";

export default {
	data() {
		return{
			language: this.$route.params.lang,
			bounce: false,
		}
	},
	props: [
		"title",
		"slug",
		"black",
	],
	watch: {
		"$route": function () {
			this.language = this.$route.params.lang;
		}
	},
	created() {
		bus.$on("modalBounce", (error) => {
			this.bounce = true;
			setTimeout(() => {
				this.bounce = false;
			}, 1000);
		});
		bus.$on("modalClose", (error) => {
			this.bodyScroll(true)
		});
	},
	methods: {
		bodyScroll(remove) {
			if (remove)
				document.querySelector("body").classList.remove("no--scroll")
			else
				document.querySelector("body").classList.add("no--scroll")
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/blocks/modal-block/modal.block.js